import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../../../core/Icon';
import Buttons from '../../../../core/Buttons';
import Input from '../../../../core/Input';
import ButtonPlus from '../../../../core/ButtonPlus';

// import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledWidgetWrap = styled.div`
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${rem('115px')};
`;

const StyledText = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  margin: 0;
  font-family: ${props => props.theme.fonts.bold};
  font-size: 0.875rem;
  text-align: center;
  line-height: 1;
  margin: 0 0 0.5rem 0;
`;

const StyledTimeWrap = styled.div`
  align-items: center;
  display: flex;
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${rem('24px')};
  justify-content: center;
  margin: 0;
`;

const StyledTrafficWrap = styled.div`
  font-size: ${rem('12px')};
  line-height: 1;
  text-align: center;
`;

const StyleWidgetIcon = styled(Icon)`
  height: 2.8rem;
  margin: 0 0.5rem 0 0;
  width: 2.8rem;
`;

const StyledTrafficSignal = styled(Icon)`
  margin: 0 0.3rem 0 0;
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

const StyledCenterWrap = styled.div`
  padding: ${rem('15px')} ${rem('8px')};
  text-align: center;
`;

const StyledStartText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: 1rem;
`;

const StyledAdressIcon = styled(ButtonPlus)`
  height: ${rem('24px')};
  margin: 0 ${rem('5px')};
  width: ${rem('24px')};
  background-color: ${props => props.theme.colors.dark};
`;

const StyledCompletAdressWrap = styled.div`
  padding: ${rem('11px')} ${rem('10px')};
  text-align: right;
`;

const StyledCompletAdressText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: 1rem;
  text-align: left;
`;

const StyledAdressInput = styled(Input)`
  input {
    padding: ${rem('8px')} ${rem('10px')} ${rem('6px')};
    font-size: ${rem('13px')};
    font-weight: bold;
    border: 0 none;
  }
`;

const StyledCompletAdressButton = styled(Buttons)`
  background-color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  line-height: ${rem('8px')};
  margin: ${rem('10px')} 0 0;
  font-size: ${rem('12px')};
  text-transform: capitalize;
  padding: ${rem('11px')} ${rem('15px')};
  :hover {
    background-color: ${props => props.theme.colors.graySad};
  }
`;

const StyledEditButton = styled(Buttons)`
  background-color: ${props => props.theme.colors.dark};
  padding: ${rem('3px')};
  margin: 0 ${rem('5px')};
  :hover {
    background-color: ${props => props.theme.colors.graySad};
  }
`;

const StyledIcon = styled(Icon)`
  width: ${props => props.theme.icons[props.size].width};
  height: ${props => props.theme.icons[props.size].height};
  margin: 0 !important;
`;

const StyledConfigLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  font-family: ${props => props.theme.fonts.medium};
`;

const StyledTrafficContainer = styled.div`
  padding: ${rem('12px')} 0.625rem 1.5rem 0.625rem;
`;

export {
  StyledWidgetWrap,
  StyledText,
  StyledTimeWrap,
  StyledTrafficWrap,
  StyleWidgetIcon,
  StyledTrafficSignal,
  StyledCenterWrap,
  StyledStartText,
  StyledAdressInput,
  StyledAdressIcon,
  StyledCompletAdressWrap,
  StyledCompletAdressText,
  StyledCompletAdressButton,
  StyledEditButton,
  StyledIcon,
  StyledConfigLink,
  StyledTrafficContainer
};
